import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/app/[lang]/about/OurPeople.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/OurMission.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/OurVision.jsx");
